var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "speakLoading" }, [
    _c("div", { class: _vm.isplay ? "colorfulPulse" : "stop colorfulPulse" }, [
      _c("span", { staticClass: "item-1" }),
      _vm._v(" "),
      _c("span", { staticClass: "item-2" }),
      _vm._v(" "),
      _c("span", { staticClass: "item-3" }),
      _vm._v(" "),
      _c("span", { staticClass: "item-4" }),
      _vm._v(" "),
      _c("span", { staticClass: "item-5" }),
      _vm._v(" "),
      _c("span", { staticClass: "item-6" }),
      _vm._v(" "),
      _c("span", { staticClass: "item-7" }),
    ]),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isplay,
            expression: "isplay",
          },
        ],
        staticClass: "please",
      },
      [_vm._v("请说话")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/speakLoading.vue?vue&type=template&id=ca08a1a8&scoped=true&
// module id = null
// module chunks = 